export const abdmintegratorMenuDef = [
    {
        "name": "menu.integrator_dashboard_ws_format",
        "icon": "fa fa-building-o",
        "data": {
            "nav_url": "integrator_dashboard_ws_format"
        },
        "children": [
            
            {
                "name": "ABDM Master",
                "resource": "integrator_master_abdm",
                "icon": "fa fa-plus-square",
                "url": "integrator_master_abdm",
                "auto_crud": true,
                "breadcrumb": "integrator_master_abdm",
                "check_permission": false
            },
            {
                name: 'ABDM Connector',
                resource: 'system_config',
                icon: 'fa fa-plus-square',
                url: 'system_config',
                auto_crud: true,
                breadcrumb: 'system_config',
                check_permission: false
            },
            {
                "name": "ABDM Onboard",
                "resource": "abdm_system_onboard_format",
                "icon": "fa fa-plus-square",
                "url": "abdm_system_onboard_format",
                "auto_crud": true,
                "breadcrumb": "abdm_system_onboard_format",
                "check_permission": false
            },
            {
                "name": "ABDM System Template",
                "resource": "abdm_system_onboard_template",
                "icon": "fa fa-plus-square",
                "url": "abdm_system_onboard_template",
                "auto_crud": true,
                "breadcrumb": "abdm_system_onboard_template",
                "check_permission": false
            },
            {
                "name": "ABDM System Clone",
                "resource": "abdm_system_onboard_clone",
                "icon": "fa fa-plus-square",
                "url": "abdm_system_onboard_clone",
                "auto_crud": true,
                "breadcrumb": "abdm_system_onboard_clone",
                "check_permission": false
            },
            {
                "name": "ABDM System Onboard",
                "resource": "system_onboard",
                "icon": "fa fa-plus-square",
                "url": "system_onboard",
                "auto_crud": true,
                "breadcrumb": "system_onboard",
                "check_permission": false
            },
            {
                "name": "ABDM Value Mapper",
                "resource": "value_mapper",
                "icon": "fa fa-plus-square",
                "url": "value_mapper",
                "auto_crud": true,
                "breadcrumb": "value_mapper",
                "check_permission": false
            }
        ]
    }
]
    
    


